import { Table as TableBase } from '@mantine/core';

import tableClasses from './table.module.css';

export const TableTheme = TableBase.extend({
	classNames: tableClasses,
});
